import { render, staticRenderFns } from "./ConfiguracionEstatus.vue?vue&type=template&id=f5bbbc78&scoped=true"
import script from "./ConfiguracionEstatus.vue?vue&type=script&lang=js"
export * from "./ConfiguracionEstatus.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionEstatus.vue?vue&type=style&index=0&id=f5bbbc78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bbbc78",
  null
  
)

export default component.exports